/**
 * @file Polls the deployed build identity and raises the refresh prompt when it differs.
 * A response without a finite numeric `date` yields null and dispatches nothing.
 */
import Environment from "../Environment/Environment";
import Http from "../Http/Http";
import Constants from "../Action/Constants";
import Store from "../Store/Store";

class VersionSignal {

  private interval: any;
  public version: number = Environment.getBuildDate();
  private loop: number = 1000 * 60 * 5; // 5 min

  // shouldSkipListenNow === true when the user clicks no on the update version window
  public listen(shouldSkipListenNow?: boolean): void {
    if (Environment.hasVersionSignal() === false) {
      return;
    }

    if (!shouldSkipListenNow) {
      this.checkNewVersion();
    }

    this.interval = setInterval(() => {
      this.checkNewVersion();
    }, this.loop);
  }

  public checkNewVersion(): void {
    this.getDeployedVersion().then(date => {
      if (date === null) {
        return;
      }

      if (date !== this.version) {
        Store.getConfigurator().dispatch({
          type: Constants.NEW_VERSION_AVAILABLE
        });

        return clearInterval(this.interval);
      }

      Store.getConfigurator().dispatch({
        type: Constants.NEW_VERSION_IGNORE
      });
    });
  }

  public getDeployedVersion(): Promise<number | null> {
    // The cache-buster goes in the path because a GET drops the params argument.
    return Http.get(`${Environment.getVersionUrl()}?t=${Date.now()}`, {}, false)
    .then(res => {
      const date = res.data && res.data.date;

      return typeof date === "number" && isFinite(date) ? date : null;
    })
    .catch(() => null);
  }
}

export default new VersionSignal();
